import React from 'react';
import { useLeaflet } from 'react-leaflet';
import { useWindowWidth } from '../../helper';
import config from '../../config/config';

const GestureHandler = () => {
    const { map } = useLeaflet();
    const [size] = useWindowWidth();
    const {breakpoints} = config;

    React.useEffect(() => {
        if (size >= breakpoints.sm) {
            map.gestureHandling.enable();
        } else {
            map.gestureHandling.disable();
        }
    }, [size, map.gestureHandling, breakpoints]);

    return null;
};

export default GestureHandler;
